import { HIDDEN_SELECTOR } from '../keyboard-nav-support';

// Collapse internal runs of whitespace to a single space (and trim) so matching is
// insensitive to whitespace differences. This matters because the highlight modifier
// (`bold-matching-text`) pads matches with boundary spaces, which can leave duplicate
// spaces in an item's `textContent`; without normalizing, a single-space query would
// then fail to match a label the filter itself had spaced out (e.g. "Item  2").
function normalizeForMatch(text) {
  return (text ?? '').replace(/\s+/g, ' ').trim().toUpperCase();
}

function displayElementFor(el, { multiselect, excludeId }) {
  if (excludeId && el.id === excludeId) return null;

  return multiselect ? el.parentElement : el;
}

function matchMenuItem(el, { normalizedValue, multiselect, excludeId }) {
  let element = displayElementFor(el, { multiselect, excludeId });
  if (!element) return false;

  let isMatch = normalizeForMatch(element.textContent).includes(normalizedValue);

  element.classList.toggle(HIDDEN_SELECTOR, !isMatch);

  return isMatch;
}

/**
 * Simple, case-insensitive text filter shared by every menu-based dropdown.
 *
 * Toggles the `HIDDEN_SELECTOR` class on each item's display element based on whether
 * its text content includes the provided value, and returns the list of matching items.
 *
 * @param {Element[]} elements the navigable item elements to filter
 * @param {string} value the current search/filter value
 * @param {object} [options]
 * @param {boolean} [options.multiselect] when true, the parent element of each item is toggled
 * @param {string} [options.excludeId] id of an item to skip (e.g. a "select all" option)
 * @returns {Element[]} the matching item elements
 */
export function filterMenuItemsByText(
  elements = [],
  value = '',
  { multiselect = false, excludeId } = {}
) {
  let normalizedValue = normalizeForMatch(value);

  return elements.filter(el => matchMenuItem(el, { normalizedValue, multiselect, excludeId }));
}

export default { filterMenuItemsByText };
